import { type ErrorComponentProps, useRouter } from '@tanstack/react-router';

import { StateError } from '@/components/app/state-error';

/**
 * Error boundary for the /connect/* hand-off pages.
 *
 * These routes sit outside `_authed` (they render chrome-free for the mobile
 * system-browser hand-off), so they don't inherit `AuthedRouteError` — without
 * this, a transient session-fetch failure in `beforeLoad` fell through to the
 * router's generic error screen with no retry, on the page whose whole job is
 * completing a customer's Meta connection.
 */
export function ConnectRouteError({ reset }: ErrorComponentProps) {
  const router = useRouter();
  const retry = () => {
    reset();
    void router.invalidate();
  };

  return (
    <div className="flex min-h-svh items-center justify-center bg-background p-6">
      <StateError
        className="w-full max-w-lg"
        message="We could not load your session. Please try again."
        onRetry={retry}
      />
    </div>
  );
}
